import { DataTableSortStatus } from 'mantine-datatable';

export const TABLE_CONSTANTS = {
  PAGE_SIZE: 100,
  DEFAULT_PRICE_RANGE: [0, 200000000000] as [number, number],
  DEFAULT_SORT: {
    columnAccessor: 'created',
    direction: 'desc',
  } as DataTableSortStatus,
};
